import { createApp } from 'vue'
import App from './App.vue'
import { Swipe, SwipeItem,showSuccessToast, showFailToast,ImagePreview,Toast,Popup } from 'vant';
import 'vant/lib/index.css';
const app = createApp(App);
app.use(Swipe);
app.use(SwipeItem);
app.use(Popup);
app.use(ImagePreview);
app.mount('#app')
